// extracted by mini-css-extract-plugin
export var grid = "_redotech-redo-web-src-grid-grid";
export var span1 = "_redotech-redo-web-src-grid-span-1";
export var span10 = "_redotech-redo-web-src-grid-span-10";
export var span10L = "_redotech-redo-web-src-grid-span-10-l";
export var span10M = "_redotech-redo-web-src-grid-span-10-m";
export var span10Xl = "_redotech-redo-web-src-grid-span-10-xl";
export var span11 = "_redotech-redo-web-src-grid-span-11";
export var span11L = "_redotech-redo-web-src-grid-span-11-l";
export var span11M = "_redotech-redo-web-src-grid-span-11-m";
export var span11Xl = "_redotech-redo-web-src-grid-span-11-xl";
export var span12 = "_redotech-redo-web-src-grid-span-12";
export var span12L = "_redotech-redo-web-src-grid-span-12-l";
export var span12M = "_redotech-redo-web-src-grid-span-12-m";
export var span12Xl = "_redotech-redo-web-src-grid-span-12-xl";
export var span1L = "_redotech-redo-web-src-grid-span-1-l";
export var span1M = "_redotech-redo-web-src-grid-span-1-m";
export var span1Xl = "_redotech-redo-web-src-grid-span-1-xl";
export var span2 = "_redotech-redo-web-src-grid-span-2";
export var span2L = "_redotech-redo-web-src-grid-span-2-l";
export var span2M = "_redotech-redo-web-src-grid-span-2-m";
export var span2Xl = "_redotech-redo-web-src-grid-span-2-xl";
export var span3 = "_redotech-redo-web-src-grid-span-3";
export var span3L = "_redotech-redo-web-src-grid-span-3-l";
export var span3M = "_redotech-redo-web-src-grid-span-3-m";
export var span3Xl = "_redotech-redo-web-src-grid-span-3-xl";
export var span4 = "_redotech-redo-web-src-grid-span-4";
export var span4L = "_redotech-redo-web-src-grid-span-4-l";
export var span4M = "_redotech-redo-web-src-grid-span-4-m";
export var span4Xl = "_redotech-redo-web-src-grid-span-4-xl";
export var span5 = "_redotech-redo-web-src-grid-span-5";
export var span5L = "_redotech-redo-web-src-grid-span-5-l";
export var span5M = "_redotech-redo-web-src-grid-span-5-m";
export var span5Xl = "_redotech-redo-web-src-grid-span-5-xl";
export var span6 = "_redotech-redo-web-src-grid-span-6";
export var span6L = "_redotech-redo-web-src-grid-span-6-l";
export var span6M = "_redotech-redo-web-src-grid-span-6-m";
export var span6Xl = "_redotech-redo-web-src-grid-span-6-xl";
export var span7 = "_redotech-redo-web-src-grid-span-7";
export var span7L = "_redotech-redo-web-src-grid-span-7-l";
export var span7M = "_redotech-redo-web-src-grid-span-7-m";
export var span7Xl = "_redotech-redo-web-src-grid-span-7-xl";
export var span8 = "_redotech-redo-web-src-grid-span-8";
export var span8L = "_redotech-redo-web-src-grid-span-8-l";
export var span8M = "_redotech-redo-web-src-grid-span-8-m";
export var span8Xl = "_redotech-redo-web-src-grid-span-8-xl";
export var span9 = "_redotech-redo-web-src-grid-span-9";
export var span9L = "_redotech-redo-web-src-grid-span-9-l";
export var span9M = "_redotech-redo-web-src-grid-span-9-m";
export var span9Xl = "_redotech-redo-web-src-grid-span-9-xl";
export var stretch = "_redotech-redo-web-src-grid-stretch";